import { assert } from './assert-sidecar'
import { l } from './imports'
import { b } from './rando'
import { normalizeSafe2 } from './vecUtil'
import { vecUtil } from './vecUtil-sidecar'

export interface IIJ {
  i: number
  j: number
}

export interface IXY {
  x: number
  y: number
}

export interface IXYD {
  x: number
  y: number
  isDead: boolean
}
export const distanceSquaredIJ = (a: IIJ, b: IIJ) => {
  let dx = a.i - b.i
  let dy = a.j - b.j
  return dx * dx + dy * dy
}
export const distanceSimpleIJ = (a: IIJ, b: IIJ) => {
  let dx = a.i - b.i
  let dy = a.j - b.j
  return Math.abs(dx) + Math.abs(dy)
}
export const distanceSimple = (
  x1: number,
  y1: number,
  x2: number,
  y2: number,
) => {
  let dx = x1 - x2
  let dy = y1 - y2
  return Math.abs(dx) + Math.abs(dy)
}
export const halfwayBetweenX = (a: IXY, b: IXY) => {
  return (a.x + b.x) / 2
}
export const halfwayBetweenY = (a: IXY, b: IXY) => {
  return (a.y + b.y) / 2
}
export const isNextToIJ = (a: IIJ, b: IIJ) => {
  // if (node.k !== end.k) {
  //   return false
  // }
  let dx = Math.abs(a.i - b.i)
  let dy = Math.abs(a.j - b.j)
  if (dx + dy > 1) {
    return false
  }
  return true
}

export const isNextToForBuildingIJ = (a: IIJ, b: IIJ) => {
  // if (node.k !== end.k) {
  //   return false
  // }
  let dx = Math.abs(a.i - b.i)
  let dy = Math.abs(a.j - b.j)
  if (dx + dy <= 1) {
    return true
  }
  if (dx === 0 && dy <= 2) {
    return true
  }
  return false
}

export const isPrettyCloseToIJ = (a: IIJ, b: IIJ) => {
  // if (node.k !== end.k) {
  //   return false
  // }
  let dx = Math.abs(a.i - b.i)
  let dy = Math.abs(a.j - b.j)
  if (dx + dy > 2) {
    return false
  }
  return true
}

export const isNextToOrAtIJ = (allowNextTo: boolean, a: IIJ, b: IIJ) => {
  if (allowNextTo) {
    return isNextToIJ(a, b)
  }
  return isAtIJ(a, b)
}

export const distanceSquared = (
  x1: number,
  y1: number,
  x2: number,
  y2: number,
) => {
  let dx = x1 - x2
  let dy = y1 - y2
  return dx * dx + dy * dy
}

export const distanceNormal = (
  x1: number,
  y1: number,
  x2: number,
  y2: number,
) => {
  let dx = x2 - x1
  let dy = y2 - y1
  return Math.sqrt(dx * dx + dy * dy)
}

export const distanceNormalXY = (a: IXY, b: IXY) => {
  let dx = b.x - a.x
  let dy = b.y - a.y
  return Math.sqrt(dx * dx + dy * dy)
}

export const isAtIJ = (a: IIJ, b: IIJ) => {
  return a.i == b.i && a.j === b.j
}

export const isAt = (x1: number, y1: number, x2: number, y2: number) => {
  return x1 == x2 && y1 === y2
}

export function findClosestTo<T extends IIJ>(
  objs: T[],
  i: number,
  j: number,
  filter: (c: T) => boolean,
  invalid: T[] = [],
): T | null {
  let closestDistance = 10000000
  let closest: T | null = null

  l.forEach(objs, (c) => {
    let d = distanceSquared(i, j, c.i, c.j)
    if (d < closestDistance) {
      if (filter(c)) {
        if (!l.includes(invalid, c)) {
          closestDistance = d
          closest = c
        }
      }
    }
  })
  return closest
}

export function exists<T extends IIJ>(
  objs: T[],
  filter: (c: T) => boolean,
  invalid: T[] = [],
): T | null {
  for (let i = 0; i < objs.length; i++) {
    let c = objs[i]
    if (filter(c)) {
      if (!l.includes(invalid, c)) {
        return c
      }
    }
  }
  return null
}

export function findClosestXY<T extends IXY>(obj: IXY, targets: T[]) {
  let closestDistance = 0
  let closest: T | null = null
  for (let i = 0; i < targets.length; i++) {
    let t = targets[i]
    let d = distanceSquared(obj.x, obj.y, t.x, t.y)
    if (!closest || d < closestDistance) {
      closest = t
      closestDistance = d
    }
  }
  assert.notNil(closest)
  return closest
}
